import React from 'react';
import cn from 'classnames';
import Iconfont from '@base/lib/Iconfont';
import Countdown, { RenderParamType } from '@base/lib/Countdown';
import { IVariant } from 'base/interfaces/product';
import { useRouter } from 'next/router';
import Link from '@base/lib/ThemeLink';
import { useStoreState } from 'base/store';
import { useStore, observer } from 'base/store';
import useFlashSaleActivity from '@base/flashSale/useFlashSaleActivity';
import { getVariantTagType } from '@base/product/utils';
import { getTagConfig, getTagElStyles } from 'mod/product/utils';
import { IActivityCode } from 'base/interfacesV2/feature';
import Image from '@base/lib/ThemeImage';
import styles from './index.module.less';
import { useTrans } from 'base/utils/i18n';

type ProdFlashSaleBarProps = {
    shownVariant?: IVariant;
    className?: string;
};

const ProdFlashSaleBar: React.FC<ProdFlashSaleBarProps> = (props) => {
    const {
        shownVariant,
        className,
    } = props

    const { ua: { isPhone } } = useStoreState('rootStore')
    const { t } = useTrans();

    const router = useRouter();
    const { userStore } = useStore();

    const tagType = getVariantTagType(shownVariant);
    const tagConfig = getTagConfig(tagType?.toLowerCase() as IActivityCode, 'detailBanner')

    const {
        flashSale: { valid, timestamp, flashSaleListLink },
        superFlashSale: { valid: sValid, timestamp: sTimestamp },
    } = shownVariant || { flashSale: {}, superFlashSale: {} };

    const _valid = sValid || valid
    const _timestamp = sTimestamp || timestamp

    //SuperFlashSaleTag tag 优先级最高
    const isSuperFlashSaleTag = tagType == 'superFlashSale' || sValid

    const flashSaleActivity = useFlashSaleActivity({
        isFlashSale: tagType == 'flashSale' || valid,
        isSuperFlashSale: isSuperFlashSaleTag
    })

    /* super flash sale没有跳转链接 */
    const hasLink = !sValid

    if (!shownVariant || userStore.isDealer() || !userStore.isInfoLoaded()) {
        return null;
    }

    return !_valid ? null : (
        <Link href={(hasLink && flashSaleListLink) || 'javascript:void(0)'}>
            <a
                target={(isPhone || !hasLink) ? '' : '_blank'}
                rel={(isPhone || !hasLink) ? void 0 : 'noopener'}
            >
                <div
                    className={cn(
                        styles['warp'],
                        className,
                    )}
                    style={getTagElStyles(tagConfig)?.wrapStyle}
                >
                    <div
                        className={'flex'}
                        style={getTagElStyles(tagConfig)?.descStyle}
                    >
                        <div
                            className={cn(
                                "flex flex-1 flex-middle",
                                styles.title
                            )}
                            style={getTagElStyles(tagConfig)?.titleStyle}
                        >
                            {/* 先找接口tagTheme配置， 再取默认配置*/}
                            {!!tagConfig?.icon && (
                                <Image
                                    className={styles.icon}
                                    fixed
                                    src={tagConfig.icon}
                                    width={13}
                                    height={13}
                                    background={false}
                                />
                            )}
                            <span>{tagConfig?.title || t(flashSaleActivity.text || '')}</span>
                        </div>

                        <div
                            className={cn(
                                styles.desc
                            )}
                            style={getTagElStyles(tagConfig)?.descStyle}
                        >
                            <Countdown
                                className="countdown inline-block"
                                endTime={Number(_timestamp)}
                                isShowDay={true}
                                render={(o: RenderParamType) => {
                                    return `${t('web_time_ends_in')} ${o.day}:${o.hour}:${o.minute}:${o.second}`
                                }}
                                onUpdate={(container, lastSeconds) => {
                                    if (lastSeconds === 0) {
                                        router.reload();
                                    }
                                }}
                            />
                            {(!isPhone && hasLink) && (
                                <Iconfont className={'icon-arrow-right'}/>
                            )}
                        </div>
                    </div>
                </div>
            </a>
        </Link>
    )
};

export default observer(ProdFlashSaleBar);